import { render, staticRenderFns } from "./MyriadSlider.vue?vue&type=template&id=d1561e90&scoped=true&"
import script from "./MyriadSlider.vue?vue&type=script&lang=js&"
export * from "./MyriadSlider.vue?vue&type=script&lang=js&"
import style0 from "./MyriadSlider.vue?vue&type=style&index=0&id=d1561e90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.8_cache-loa_04cfefe4e5633ef36867eab2fc0c6666/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1561e90",
  null
  
)

export default component.exports